export default __webpack_public_path__ + "static/media/system-log.96d219f5.svg";